module.exports = __webpack_public_path__ + "img/mobile-banner-04-0626.cdf6b1bf.png";